import React, { useEffect } from 'react';
import { useAssets } from 'hooks';

import { useIam } from 'api/hooks/useIam/useIam';

import { DesktopDashboard } from './DesktopDashboard';

export const DesktopDashboardContainer = () => {
  const { isConnected } = useIam();
  const { getAssets, assets } = useAssets();

  useEffect(() => {
    async function get() {
      getAssets();
    }

    if (isConnected()) {
      get();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConnected]);

  return <DesktopDashboard batteries={assets} />;
};
